"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayerForm = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactUseFormState = require("react-use-form-state");
var _browserRum = require("@datadog/browser-rum");
var _reactstrap = require("reactstrap");
var _ = require("./..");
var _Sources = require("@studio/constants/Sources");
var _utils = require("../../utils");
var _LayerForm = require("./LayerForm.styled");
var _sourceFileHelper = require("../../utils/sourceFileHelper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
var LayerForm = exports.LayerForm = function LayerForm(_ref) {
  var type = _ref.type,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    _ref$supportedFileTyp = _ref.supportedFileTypes,
    supportedFileTypes = _ref$supportedFileTyp === void 0 ? '' : _ref$supportedFileTyp;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    file = _useState2[0],
    setFile = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isFileValid = _useState4[0],
    setIsFileValid = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    errorMessages = _useState6[0],
    setErrorMessages = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    isAdding = _useState8[0],
    setIsAdding = _useState8[1];
  var _useFormState = (0, _reactUseFormState.useFormState)({
      name: ''
    }),
    _useFormState2 = (0, _slicedToArray2["default"])(_useFormState, 2),
    formState = _useFormState2[0],
    text = _useFormState2[1].text;
  var DDErrorMessages = [];
  var clearErrorMessages = function clearErrorMessages() {
    setErrorMessages([]);
    DDErrorMessages = [];
  };
  var addButton = 'Upload';
  addButton = isAdding ? addButton + 'ing...' : addButton;
  var handleFileChange = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
      var file, isImageFile, isValidDimensions, isValidSize, isValidFile, sourceType, _t;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            file = event.target.files[0];
            clearErrorMessages();
            formState.setField('name', file === null || file === void 0 ? void 0 : file.name);
            isImageFile = (0, _sourceFileHelper.getFileSourceType)(file === null || file === void 0 ? void 0 : file.name) === _Sources.IMAGE_FILE;
            if (!(file && !isImageFile)) {
              _context.next = 1;
              break;
            }
            setFile(null);
            setIsFileValid(false);
            setErrorMessages(function (prevMessages) {
              return [].concat((0, _toConsumableArray2["default"])(prevMessages), ['File type not supported']);
            });
            DDErrorMessages.push('File type not supported');
            _context.next = 4;
            break;
          case 1:
            _t = file;
            if (!_t) {
              _context.next = 3;
              break;
            }
            _context.next = 2;
            return (0, _sourceFileHelper.validateImageDimensions)(file);
          case 2:
            _t = _context.sent;
          case 3:
            isValidDimensions = _t;
            isValidSize = file && (0, _sourceFileHelper.validateImageFileSize)(file);
            isValidFile = isValidDimensions && isValidSize;
            setFile(isValidFile ? file : null);
            setIsFileValid(isValidFile);
            if (file && !isValidSize) {
              setErrorMessages(function (prevMessages) {
                return [].concat((0, _toConsumableArray2["default"])(prevMessages), ['File exceeds size limitation of (5MB)']);
              });
              DDErrorMessages.push('File exceeds size limitation of (5MB)');
            }
            if (file && !isValidDimensions) {
              setErrorMessages(function (prevMessages) {
                return [].concat((0, _toConsumableArray2["default"])(prevMessages), ['File exceeds maximum dimensions (1920 x 1080 pixels)']);
              });
              DDErrorMessages.push('File exceeds maximum dimensions (1920 x 1080 pixels)');
            }
          case 4:
            if (file && DDErrorMessages.length > 0) {
              sourceType = type === 'overlay' ? 'Overlay' : 'Background';
              _browserRum.datadogRum.addError("".concat(sourceType, " upload failed"), {
                error: {
                  fileName: file.name,
                  fileSize: (0, _utils.formatBytes)(file.size),
                  errors: DDErrorMessages
                }
              });
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleFileChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleAdd = function handleAdd(e) {
    e.preventDefault();
    setIsAdding(true);
    var layer = {
      title: formState.values.name,
      type: _Sources.IMAGE_FILE,
      file: file
    };
    onSubmit(layer);
  };
  var isAddButtonDisabled = !formState.validity.name || !file || isAdding;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Form, {
    "data-testid": "".concat(type, "CreateForm"),
    onSubmit: handleAdd
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Row, null, /*#__PURE__*/_react["default"].createElement(_LayerForm.StyledFileInputCol, {
    md: 5
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Label, {
    id: "".concat(type, "FileLabel"),
    htmlFor: "".concat(type, "FileFile")
  }, "Upload new ", type), /*#__PURE__*/_react["default"].createElement(_LayerForm.StyledInput, {
    "data-testid": "".concat(type, "FileInput"),
    type: "file",
    "aria-labelledby": "".concat(type, "FileLabel"),
    name: "file",
    onChange: handleFileChange,
    id: "".concat(type, "FileFile"),
    className: !isFileValid ? 'is-invalid' : '',
    accept: ".png, .jpeg, .jpg, .gif"
  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormFeedback, null, errorMessages.map(function (message, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      style: {
        whiteSpace: 'nowrap'
      }
    }, message);
  })))), /*#__PURE__*/_react["default"].createElement(_LayerForm.StyledAllowedMediaCol, null, /*#__PURE__*/_react["default"].createElement(_LayerForm.StyledAllowedMediaTypes, null, supportedFileTypes))), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Label, {
    id: "".concat(type, "NameLabel"),
    htmlFor: "layerName"
  }, type.charAt(0).toUpperCase() + type.slice(1), " name"), /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, (0, _extends2["default"])({
    "data-testid": "".concat(type, "NameInput"),
    id: "".concat(type, "Name"),
    "aria-labelledby": "".concat(type, "NameLabel")
  }, text({
    name: 'name',
    validate: function validate(t) {
      return t.length >= 1;
    },
    validateOnBlur: false,
    touchOnChange: true
  }), {
    invalid: formState.touched.name && !formState.validity.name,
    required: true
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormFeedback, null, "Uh oh! A name is required.")), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "float-end"
  }, /*#__PURE__*/_react["default"].createElement(_.Button, {
    "data-testid": "addButton",
    color: "primary",
    disabled: isAddButtonDisabled,
    "data-dd-action-name": "Upload a local ".concat(type, " file")
  }, addButton), ' ', /*#__PURE__*/_react["default"].createElement(_LayerForm.StyledCloseButton, {
    "data-testid": "closeButton",
    "data-dd-action-name": "Close [".concat(type, "] upload a local file"),
    color: "light",
    variant: "outlined",
    onClick: function onClick(e) {
      e.preventDefault();
      onCancel();
      clearErrorMessages();
    }
  }, 'Cancel')))));
};
LayerForm.propTypes = {
  type: _propTypes["default"].oneOf(['overlay', 'background']),
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  supportedFileTypes: _propTypes["default"].string
};